import queryString from 'query-string';
import http from '../httpConfig';
import { API_ENDPOINTS } from '../utils/apiConstant';
import { buildPagingResponse } from '../utils/methods';
import { EditApi, EditSettings, List } from '../interfaces/reservation.interface';

const list = (payload: List) => {
  const { searchText, source, status, startDate, endDate, platform, property, reservationStatus, assignedTo, reviewedBy, invoiceId, isActive, ...others } = payload;
  const paging = buildPagingResponse(others);
  const url = `${API_ENDPOINTS.listReservations}?${queryString.stringify(paging)}`;
  return http.post(url, {
    source,
    status,
    search: searchText,
    property_id: property,
    start_date: startDate,
    end_date: endDate,
    platform_id: platform,
    reservation_status: reservationStatus,
    assigned_to: assignedTo,
    reviewed_by: reviewedBy,
    invoice_id: invoiceId,
    is_active: isActive
  });
};

const edit = (id: string, payload: EditApi) => {
  return http.put(`${API_ENDPOINTS.reservations}/${id}`, payload);
};

const get = (id: string) => {
  return http.get(`${API_ENDPOINTS.reservations}/${id}`);
};

const lookup = (payload: any) => {
  const url = `${API_ENDPOINTS.lookupReservations}?${queryString.stringify({ search: payload.searchText, property_id: payload.propertyId, duration: 'month', duration_number: 3 })}`;
  return http.get(url);
};

const sync = () => {
  return http.post(API_ENDPOINTS.syncReservations, { type: 'full' });
};

const updateSettings = (id: string, payload: EditSettings) => {
  return http.patch(`${API_ENDPOINTS.reservations}/${id}/settings`, payload);
};

const payoutDetails = (id: string) => {
  return http.get(`${API_ENDPOINTS.reservationPayoutDetails(id)}`);
};

const ReservationService = {
  list,
  get,
  edit,
  lookup,
  sync,
  updateSettings,
  payoutDetails
};

export default ReservationService;


